import React, { useState } from 'react'
import MentoriaCac from '../mentoria-cac/mentoriaCac';
import MentoriaRuta from '../mentoria-ruta/mentoriaRuta';
import './mentoriaResultados.scss'
import ResultCard from './result-card/resultCard';
import ScoreBar from './score-bar/scoreBar';

interface MentoriaResultadosProps {
   faces: Array<string>;
   toolTip: string;
   propositosImages: Array<string>;
   results: any;
   agendamientoIcons: Array<string>;
   rutaPhotos: Array<string>;
}

const MentoriaResultados = (props: MentoriaResultadosProps) => {
   const [showRoute, setShowRoute] = useState(false);
   const [showCac, setShowCac] = useState(false);
   const { results } = props;

   const handleContinueResults = () => {
      //Logica para mostrar Cac
      if (results.wayToMyHouse) {
         setShowCac(true);
      } else {
         setShowRoute(true);
      }
   }

   const handleShowRoute = () => {
      setShowRoute(true);
      setShowCac(false);
   }

   return (
      <div className="mentoria-resultados">
         {(!showRoute && !showCac) ?
            <>
               <header className="mentoria-resultados__header">
                  <img
                     src={props.propositosImages[0]}
                     alt={"Propósito"}
                     className="mentoria-resultados__header__image"
                  />
                  <div className="mentoria-resultados__header__description">
                     <h2 className="mentoria-resultados__header__description__title">
                        Tu resultado
                     </h2>
                     <p className="mentoria-resultados__header__description__text">
                        Con la información que nos suministraste en la encuesta de
                        diagnóstico financiero, realizaremos el análisis de tus
                        finanzas y queremos entregarte este resultado que te
                        permitirá encontrar oportunidades para continuar creciendo y
                        avanzando hacia tus propósitos.
                     </p>
                  </div>
               </header>
               <body className="mentoria-resultados__body">
                  <div className="mentoria-resultados__body__info">
                     <h2 className="mentoria-resultados__body__info__title">
                        Tu indicador de educación y salud financiera nos dice que:
                     </h2>
                     <h3 className="mentoria-resultados__body__info__subtitle">
                        {results.financialHealth.title}
                     </h3>
                     <p className="mentoria-resultados__body__info__text">
                        {results.financialHealth.challengeDescription}
                     </p>
                  </div>
                  {/*Results card*/}
                  <div className="mentoria-resultados__body__results-card">
                     <div className="mentoria-resultados__body__results-card__content">
                        <header className="mentoria-resultados__body__results-card__content__header">
                           <h2 className="mentoria-resultados__body__results-card__content__header__number">
                              {results?.totalScore || 0}
                           </h2>
                           <div className="mentoria-resultados__body__results-card__content__header__description">
                              <h4 className="mentoria-resultados__body__results-card__content__header__description__title">
                                 Tu puntaje
                              </h4>
                              <p className="mentoria-resultados__body__results-card__content__header__description__subtitle">
                                 Puntaje máximo 100
                              </p>
                           </div>
                        </header>
                        <body className="mentoria-resultados__body__results-card__content__body">
                           {results?.score?.map((score) => {
                              return (
                                 <ScoreBar
                                    key={score.name}
                                    title={score.name}
                                    color={score.color || '#1AA8A2'}
                                    score={score.value}
                                    toolTip={props.toolTip}
                                    toolTipHelp={score.description}
                                 />
                              );
                           })}
                        </body>
                     </div>
                  </div>
                  <div className="mentoria-resultados__body__section-container">
                     <section className="mentoria-resultados__body__section">
                        <p className="mentoria-resultados__body__section__text">Este indicador se compone 4 variables que te mostrarán en donde tienes oportunidades de mejora.</p>
                        {results.indicators && results?.indicators.map((indicator) => {
                           return (
                              <ResultCard
                                 title={indicator.name}
                                 description={indicator.description}
                                 score={indicator.value}
                                 faces={props.faces}
                              />
                           );
                        })}
                     </section>
                  </div>
                  <div className="mentoria-resultados__body__button-container">
                     <button className="mentoria-resultados__body__button-container__button" onClick={handleContinueResults}>Continuar</button>
                  </div>
               </body>
            </> : (showRoute && !showCac) ?
               <MentoriaRuta results={results} rutaPhotos={props.rutaPhotos} agendamientoIcons={props.agendamientoIcons}></MentoriaRuta>
               : (!showRoute && showCac) &&
               <MentoriaCac clickCallback={handleShowRoute}></MentoriaCac>
         }
      </div>
   );
}

export default MentoriaResultados;